<template>
  <div :style="[styles.base]"
       :class="[{'wang-editor-text-box--hide':isCarouselAnimation}]"
       @click="handleClickEvent()"
       @mouseenter="handleEvent('hover')">
    <div v-html="wangEditorHtml"
         :class="configurationData.isShowScrollBar ? 'wang-editor-text-content-show' : 'wang-editor-text-content-hide'"
         :style="animateOrScrollBar"></div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CPublicWangEditorText',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-wang-editor-text-',
    };
  },
  computed: {
    isCarouselAnimation() {
      const { animate = {} } = this.styles;
      if (animate['animation-name'] === 'carousel') return true;
      return false;
    },
    wangEditorHtml() {
      let editorTextHtml = this.configurationData?.textHtml || '';
      if (!this.$isInEditor) {
        editorTextHtml = this.getRemHtml(this.configurationData?.textHtml);
      }
      return editorTextHtml;
    },
    hideOnPlatform() {
      return this.configurationData.hideOnPlatform;
    },
    hideOnDevices() {
      return this.configurationData.hideOnDevices;
    },
    animateOrScrollBar() {
      const { backgroundColorHighlight, backgroundColorGrey } = this.configurationData;
      return Object.assign({}, this.styles.animate, {
        '--backgroundColorHighlight': backgroundColorHighlight,
        '--backgroundColorGrey': backgroundColorGrey,
        '--scrollBarWidth': this.deviceMode === 'pc' ? '5px' : '0.06rem',
      });
    },
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {},
    getRemHtml(htmlStr) {
      const machStr = /\s+\d+px/g;
      const machArr = htmlStr.match(machStr) ;
      console.log(machArr);
      let htmlVal = htmlStr;
      if (machArr !== null) {
        for (let i = 0; i < machArr.length;i++) {
          const remStr = common.tool.transformToRem(machArr[i].trim());
          console.log(machArr[i]);
          htmlVal = htmlVal.replace(machArr[i], ` ${remStr}`);
        }
      }
      return htmlVal;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';

.wang-editor-text-box--hide {
  overflow: hidden;
}

.wang-editor-text-content-show,
.wang-editor-text-content-hide {
  height: 100%;
  overflow-y: auto;
  font-size: .16rem;
  line-height: 1.5;

  &-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

// 滚动条展示时样式
.wang-editor-text-content-show::-webkit-scrollbar-thumb {
  background: var(--backgroundColorHighlight);
}

.wang-editor-text-content-show::-webkit-scrollbar {
  width: var(--scrollBarWidth);
}

.wang-editor-text-content-show::-webkit-scrollbar-track-piece {
  background-color: var(--backgroundColorGrey);
}
// 滚动条不展示时候的样式
.wang-editor-text-content-hide::-webkit-scrollbar {
  width: var(--scrollBarWidth);
}

.wang-editor-text-content-show h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: revert;
}

.wang-editor-text-content-hide h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: revert;
}

.wang-editor-text-content-hide em {
  font-style: revert;
}

.wang-editor-text-content-show em {
  font-style: revert;
}

.wang-editor-text-content-show p:first-child {
  font-size: 0.16rem;
}

.wang-editor-text-content-hide p:first-child {
  font-size: 0.16rem;
}
</style>
